import React, { useState, useEffect, useRef } from 'react';
import './slide-up.css';

// A reusable component for the slide-up animation
const SlideUpOnScroll = ({ children, delay = 0, className = '', fix = false, threshold = 0.8 }) => {
    // State to control when the 'is-in-view' class is applied
    const [isInView, setIsInView] = useState(false);
    // Ref to attach to the DOM element for Intersection Observer
    const elementRef = useRef(null);

    useEffect(() => {
        const currentElement = elementRef.current;

        if (!currentElement) return; // Exit if ref is not attached

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        
                        // If the element is in view, set state to true
                        setIsInView(true);
                        // Stop observing this element once it's animated
                        observer.unobserve(currentElement);
                    }
                });
            },
            {
                // Options for the observer:
                rootMargin: '0px',
                threshold: threshold, // Trigger when 10% of the element is visible
            }
        );
        
        // Start observing the element
        observer.observe(currentElement);

        // Cleanup function: disconnect the observer when the component unmounts
        return () => {
            if (currentElement) {
                observer.unobserve(currentElement); // Ensure unobserve before disconnect
                observer.disconnect();
            }
        };
    }); // Empty dependency array means this effect runs once after initial render

    // Combine base styles with animation classes and any additional classes passed in
    
    const moveUpOptions = ['move-up', 'move-up-2', 'move-up-3'];
    var randomIndex = Math.floor(Math.random() * moveUpOptions.length);
    
    if (fix) {
        randomIndex = 1;
    }

    //${delay > 0 ? `transition-delay-[${delay}ms]` : ''}
    const combinedClasses = `
        opacity-0 transform translate-y-[50px]
        transition-opacity duration-700 ease-out
        transition-transform duration-700 ease-out
        ${isInView ? moveUpOptions[randomIndex] : ''}
        ${className}
    `;
    
    // Sa pun asta la loc

    return (
        <div ref={elementRef} className={combinedClasses}>
            {children}
        </div>
    );
};

export default SlideUpOnScroll;